import React, { Fragment, useEffect } from 'react'
import { FourColumnLayout, ThreeColumnLayout } from '../ColumnLayout'
import KeyboardHandler from './KeyboardHandler'

export const DEFAULT_BREAKPOINTS = [650]

export default function AutoLayout({
  is3ColumnView,
  children,
  columnConfigs,
  conversationId,
  globalNavActive,
  sidebarType,
  sidebarTitle,
}) {
  const Layout = is3ColumnView ? ThreeColumnLayout : FourColumnLayout
  let config = columnConfigs['4']
  if (is3ColumnView) {
    config = conversationId
      ? columnConfigs['3-page']
      : columnConfigs['3-overview']
  }

  useEffect(
    () => {
      if (is3ColumnView) {
        document.body.classList.toggle('classic-inbox-view', true)
        document.body.classList.toggle('modern-inbox-view', false)
      } else {
        document.body.classList.toggle('classic-inbox-view', false)
        document.body.classList.toggle('modern-inbox-view', true)
      }
    },
    [is3ColumnView]
  )

  return (
    <Fragment>
      <KeyboardHandler />
      <Layout
        columnConfig={config}
        breakpoints={DEFAULT_BREAKPOINTS}
        globalNavActive={globalNavActive}
        sidebarType={sidebarType}
        sidebarTitle={sidebarTitle}
      >
        {children}
      </Layout>
    </Fragment>
  )
}
